<div class="orders-list">
  <p-table
    #dt
    stripedRows
    [rows]="25"
    [showCurrentPageReport]="true"
    [scrollable]="true"
    scrollHeight="calc(100vh - 310px)"
    [size]="'small'"
    responsiveLayout="scroll"
    [value]="orderNotesGridListing"
    [(selection)]="selectedOrderNotesGridListing"
    styleClass="p-datatable-customers no-overfollow ordersLineItems no-wrap table-hover-bg"
    [rowHover]="true"
    [rows]="20"
    [showCurrentPageReport]="true"
    [paginator]="false"
    [filterDelay]="0"
    dataKey="id"
    editMode="row"
    selectionMode="multiple"
    styleClass="table-listing">
    <ng-template pTemplate="header">
      <tr class="table-head">
        <th *ngIf="!isFromInvoiceSummary"></th>
        <th class="col-center">
          <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
        </th>
        <th class="number" pSortableColumn="type">
          Type
          <p-sortIcon field="type"></p-sortIcon>
        </th>
        <th class="status" *ngIf="!isFromInvoiceSummary">Purchase Order</th>
        <th class="name max-width-10">Description</th>
        <th class="name max-width-10">Note</th>
        <th class="name" *ngIf="!isFromInvoiceSummary">Created By</th>
        <th class="name" *ngIf="!isFromInvoiceSummary">Created date</th>
        <th class="name" pSortableColumn="lastModifiedBy">
          Modified By
          <p-sortIcon field="lastModifiedBy"></p-sortIcon>
        </th>
        <th class="name" pSortableColumn="lastModifiedDate">
          Modified date
          <p-sortIcon field="lastModifiedDate"></p-sortIcon>
        </th>
      </tr>
      <tr>
        <th *ngIf="!isFromInvoiceSummary"></th>
        <th></th>
        <th>
          <div class="d-flex">
            <input
              jniAutoCompleteBlocker
              pInputText
              type="text"
              name="type"
              id="type"
              style="max-width: 200px"
              (input)="dt.filter($any($event.target).value, 'type', 'contains')"
              placeholder=""
              class="p-column-filter p-inputtext p-component" />
          </div>
        </th>
        <th *ngIf="!isFromInvoiceSummary">
          <div class="d-flex">
            <input
              jniAutoCompleteBlocker
              pInputText
              type="text"
              name="purchaseOrderId"
              id="purchaseOrderId"
              style="max-width: 200px"
              (input)="
                dt.filter(
                  $any($event.target).value,
                  'purchaseOrderId',
                  'contains'
                )
              "
              placeholder=""
              class="p-column-filter p-inputtext p-component" />
          </div>
        </th>
        <th>
          <div class="d-flex max-width-10">
            <input
              jniAutoCompleteBlocker
              pInputText
              type="text"
              name="description"
              id="description"
              (input)="
                dt.filter($any($event.target).value, 'description', 'contains')
              "
              placeholder=""
              class="p-column-filter p-inputtext p-component" />
          </div>
        </th>
        <th>
          <div class="d-flex max-width-10">
            <input
              jniAutoCompleteBlocker
              pInputText
              type="text"
              name="note"
              id="note"
              (input)="dt.filter($any($event.target).value, 'note', 'contains')"
              placeholder=""
              class="p-column-filter p-inputtext p-component" />
          </div>
        </th>
        <th *ngIf="!isFromInvoiceSummary">
          <div class="d-flex">
            <input
              jniAutoCompleteBlocker
              pInputText
              type="text"
              name="createdBy"
              id="createdBy"
              style="max-width: 200px"
              (input)="
                dt.filter($any($event.target).value, 'createdBy', 'contains')
              "
              placeholder=""
              class="p-column-filter p-inputtext p-component" />
          </div>
        </th>
        <th *ngIf="!isFromInvoiceSummary"></th>
        <th></th>
        <th></th>
      </tr>
    </ng-template>
    <ng-template
      pTemplate="body"
      let-orderNotesGridListing
      let-editing="editing"
      let-rowIndex="rowIndex">
      <tr
        class="p-selectable-row"
        [pEditableRow]="orderNotesGridListing"
        [pSelectableRow]="orderNotesGridListing"
        [ngClass]="{ 'line-gray': !orderNotesGridListing?.isActive }"
        [pSelectableRowDisabled]="!orderNotesGridListing?.isActive">
        <td style="text-align: center" *ngIf="!isFromInvoiceSummary">
          <button
            *ngIf="!editing"
            [disabled]="!orderNotesGridListing?.isActive"
            pButton
            pRipple
            type="button"
            pInitEditableRow
            (click)="onEditRow(orderNotesGridListing)"
            icon="pi pi-pencil"
            class="p-button-rounded p-button-text"></button>
          <button
            *ngIf="editing"
            [disabled]="!orderNotesGridListing?.isActive"
            pButton
            pRipple
            type="button"
            pSaveEditableRow
            (click)="onRowEditSave(orderNotesGridListing)"
            icon="pi pi-check"
            class="p-button-rounded p-button-text p-button-success p-mr-2 selectable-color"></button>
          <button
            *ngIf="editing"
            [disabled]="!orderNotesGridListing?.isActive"
            pButton
            pRipple
            type="button"
            pCancelEditableRow
            (click)="getSalesOrderNotes(this.saleOrderId)"
            icon="pi pi-times"
            class="p-button-rounded p-button-text p-button-danger"></button>
        </td>
        <td class="col-center">
          <p-tableCheckbox
            [pSelectableRow]="orderNotesGridListing"
            [value]="orderNotesGridListing"></p-tableCheckbox>
        </td>
        <td>
          <p-cellEditor>
            <ng-template pTemplate="input">
              <p-select
                class="p-0"
                id="currency"
                [(ngModel)]="orderNotesGridListing.type"
                (change)="
                  onPurchaseorderchange(
                    orderNotesGridListing.type,
                    orderNotesGridListing.id
                  )
                "
                [options]="typeList"
                optionLabel="name"
                optionValue="name"
                [filter]="true"
                [showClear]="true">
              </p-select>
            </ng-template>
            <ng-template pTemplate="output">
              {{ orderNotesGridListing.type }}
            </ng-template>
          </p-cellEditor>
        </td>
        <td *ngIf="!isFromInvoiceSummary">
          <p-cellEditor>
            {{ purchaseOrderNumber }}
            <ng-template pTemplate="input">
              <p-select
                class="p-0"
                id="currency"
                [disabled]="
                  disabledField(orderNotesGridListing.type) ||
                  onPurchaseorderstatus
                "
                [(ngModel)]="orderNotesGridListing.purchaseOrderId"
                [options]="purchaseOrderNumber"
                [filter]="true"
                [showClear]="true">
              </p-select>
            </ng-template>
            <ng-template pTemplate="output">
              {{ orderNotesGridListing.purchaseOrderId }}
            </ng-template>
          </p-cellEditor>
        </td>
        <td class="max-width-10 text-truncate">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input
                jniAutoCompleteBlocker
                pInputText
                type="text"
                [(ngModel)]="orderNotesGridListing.description"
                required />
            </ng-template>
            <ng-template pTemplate="output">
              {{ orderNotesGridListing.description }}
            </ng-template>
          </p-cellEditor>
        </td>
        <td class="max-width-10 text-truncate">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input
                jniAutoCompleteBlocker
                pInputText
                type="text"
                [(ngModel)]="orderNotesGridListing.note"
                required />
            </ng-template>
            <ng-template pTemplate="output">
              {{ orderNotesGridListing.note }}
            </ng-template>
          </p-cellEditor>
        </td>
        <td *ngIf="!isFromInvoiceSummary">
          {{ orderNotesGridListing.createdBy }}
        </td>
        <td *ngIf="!isFromInvoiceSummary">
          <span *ngIf="orderNotesGridListing?.createdDate | hidedynamicsdate">
            {{ orderNotesGridListing.createdDate | date: "MM-dd-yyyy" }}
          </span>
        </td>
        <td>{{ orderNotesGridListing.lastModifiedBy }}</td>
        <td>
          {{ orderNotesGridListing.lastModifiedDate | date: "MM-dd-yyyy" }}
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
